<template>
	<div 
		class="fancy-radio"
		:class="[
			darkMode ? 'dark-mode' : ''
		]"
		>
		<label class="label">{{ label }}</label>
		<div class="options-container" v-if="options">
			<div 
				class="option"
				v-for="(option, index) in options"
				:key="index"
				>
				<label 
					:for="id+index+randomNum"
					:class="{
						'active': option.value === modelValue
					}">
					<input
						type="radio"
						:id="id+index+randomNum"
						:name="id"
						:value="option.value"
						:checked="option.value === value"
						@change="$emit('update:modelValue', option.value)"
						/>
					<div class="the-icon"></div>
					<div class="the-label">
						{{ option.text }}

						<div class="the-desc" v-if="option.desc">
							{{ option.desc }}
						</div>
					</div>
					
				</label>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		props: [
			'id',
			'label',
			'modelValue',
			'options',
			'value',
			'darkMode'
		],
		emits: ['update:modelValue'],
		data: () => {
			return {
				randomNum: 0
			}
		},
		methods: {
			updateValue(value) {
				// console.log(value)
				this.$emit("change", value)
			},
		},
		mounted(){
			this.randomNum = Math.random() * (99999 - 10000) + 10000
		}
	}
</script>

<style lang="sass" scoped>

.fancy-radio
	margin: 0 0 30px
	display: flex
	flex-direction: column
	width: 100%
	max-width: 30rem
	
	.label
		font-family: 'Roboto Condensed', sans-serif
		font-weight: 700
		font-size: 16px
		line-height: 1.1
		color: #252525
		margin-bottom: 10px

	.options-container

		.option
			margin-bottom: 6px

			&:last-child
				margin-bottom: 0

			label
				border-radius: 6px
				border: 1px solid rgba(#000, 0.3)
				padding: 15px
				cursor: pointer
				display: grid
				position: relative
				align-items: center
				transition: all 300ms
				grid-template-columns: 30px 1fr
				gap: 15px

				.the-icon
					width: 25px
					height: 25px
					border: 2px solid #252525
					border-radius: 50%
					margin-right: 20px
					position: relative
					display: flex
					align-items: center
					justify-content: center

					&:after
						content: ''
						width: 15px
						height: 15px
						background-color: darken(#0f0, 20%)
						border-radius: 50%
						transition: all 300ms
						opacity: 0

				.the-label
					font-family: 'Roboto', sans-serif
					font-weight: 400
					font-size: 16px
					line-height: 1.1
					color: #252525

				.the-desc
					font-family: 'Roboto', sans-serif
					font-weight: 400
					font-size: 14px
					line-height: 1.1
					color: rgba(#252525, 0.7)
					font-style: italic

				input
					position: absolute
					visibility: hidden

				&.active
					border-color: darken(#0f0, 20%)
					background-color: rgba(#0f0,0.03)

					.the-icon
						&:after
							opacity: 1

	&.dark-mode
		.label
			color: rgba(#fff, 0.7)

		.options-container
			.option
				label
					border: 1px solid rgba(#fff, 0.3)

					.the-icon
						border: 2px solid #fff

						&:after
							background-color: darken(#0f0, 20%)

					.the-label
						color: rgba(#fff, 0.7)

					&.active
						border-color: darken(#0f0, 20%)
						background-color: rgba(#0f0,0.03)


</style>

